import React from 'react'
import { useThankYouNote } from '../ThankYouNoteProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const BasicsEditor = ({ templateIndex }) => {
  const { thankYouNoteDocument: { basics } = {} } = useThankYouNote()
  const { aylaThankYouNote } = useThankYouNote()
  const { t } = useTranslation('Editor.BasicEditor')

  return (
    <EditorItemProvider sectionName="basics" item={basics}>
      <div>
        {aylaThankYouNote && (
          <div className="mb-8">
            <EditorHeading>{t('disclaimer')}</EditorHeading>
            <p>{t('description')}</p>
          </div>
        )}
        <EditorHeading>{t('addressee_details')}</EditorHeading>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-6">
          {templateIndex == 0 && (
            <>
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('salutation')}
                fieldName="salutation"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('first_name')}
                fieldName="firstName"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('last_name')}
                fieldName="lastName"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('position_title')}
                fieldName="positionTitle"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_name')}
                fieldName="companyName"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_division')}
                fieldName="companyDivision"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_street')}
                fieldName="companyStreet"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_city')}
                fieldName="companyCity"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_state')}
                fieldName="companyState"
              />
              <EditorItemField
                containerClassName="md:col-span-3"
                label={t('company_zip')}
                fieldName="companyZip"
              />
            </>
          )}
          {(templateIndex == 1 || templateIndex == 2) && (
            <>
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('salutation')}
                fieldName="salutation"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('first_name')}
                fieldName="firstName"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('last_name')}
                fieldName="lastName"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('position_title')}
                fieldName="positionTitle"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('company_name')}
                fieldName="companyName"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('company_division')}
                fieldName="companyDivision"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('address_line_1')}
                fieldName="address1"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('address_line_2')}
                fieldName="address2"
              />
              <EditorItemField
                containerClassName="md:col-span-2"
                label={t('city_state_zip')}
                fieldName="cityStateZip"
              />
            </>
          )}
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default BasicsEditor
